module.exports = __webpack_public_path__ + "img/3.202e6c61.jpg";